<template>
    <div id="second-strategy">
        <!--=====================================-->
        <!--=      Strategy Quality Area Start    =-->
        <!--=====================================-->
        <section class="section pb--80 pb_lg--40 pb_md--20">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="about-quality active mb-1">
                            <h3 class="sl-number bold mb-2 mt-5">2</h3>
                            <h2 class="title black font-weight-100 mb-4 ml-1">
                                <span class="bold">Negocio</span> como <span class="bold">medio</span>
                                <br> para <span class="bold">un fin</span>.
                            </h2>
                            <p class="black mb-1">
                                Si el capital es fundamental para impulsar el desarrollo sostenible, utilizaremos el nuestro para predicar con el ejemplo.
                                <br>
                                <br>
                                <span class="bold text-bg-primary">PARTICIPACIÓN EN EL FONDEO</span>
                            </p>
                            <div class="blog-list active">
                                <div class="post-thumbnail">
                                    <img :src="img1" alt="Blog Post">
                                </div>
                                <div class="post-content">
                                    <h5 class="bold mb-0">
                                        Arriesgamos
                                        <br>con la comunidad.
                                    </h5>
                                    <p class="w-50">
                                        RedGirasol siempre es el primero
                                        en invertir en los proyectos,
                                        si los publicamos es porque
                                        creemos en ellos.
                                    </p>
                                </div>
                            </div>

                            <p class="mb-3">
                                <span class="bold text-bg-primary">DONACIONES ESTRATÉGICAS</span>
                            </p>

                            <p class="black mb-2">Destinaremos el 2% de nuestros ingresos para fomentar el bienestar ambiental y social de nuestro país.</p>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <div class="blog-list active">
                                        <div class="post-thumbnail">
                                            <img :src="img2" alt="Blog Post">
                                        </div>
                                        <div class="post-content">
                                            <h5 class="mb-0 text-wrap-balance">
                                                <strong>Ambiental (1%).</strong>
                                                <br><span class="font-weight-100">Restauración <br>
                                                y conservación <br>
                                                de la biodiversidad
                                                mexicana.</span>
                                            </h5>
                                            <p class="text-wrap-balance">
                                                Destino de recursos en efectivo para 
                                                ONGs enfocadas en la restauración y 
                                                conservación de ecosistemas claves 
                                                mexicanos.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <div class="blog-list active">
                                        <div class="post-thumbnail">
                                            <img :src="img3" alt="Blog Post">
                                        </div>
                                        <div class="post-content">
                                            <h5 class="mb-0">
                                                <strong>Social (1%).</strong>
                                                <br><span class="font-weight-100">Fortalecimiento <br>
                                                del tejido social.</span>
                                            </h5>
                                            <p class="text-wrap-balance">
                                                Donativo en especie, descuentos 
                                                preferenciales para solicitantes en 
                                                situaciones de vulnerabilidad.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script scoped>

export default {
    name: "SecondStrategy",
    components: {
    },
    data() {
        return {
            img1: "https://cdn.redgirasol.com/nuevo_portal/fotografias/hands-team.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/fotografias/honeycomb-strategy.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/fotografias/social-strategy.png"
        }
    }
}

</script>

<style scoped>
.about-quality .sl-number {
    background: var(--color-primary);
}

.strategy-card {
    padding: 2rem;
    background-color: var(--color-black);
    color: #FFF;
    border-radius: 25px;
    min-height: 15rem;
}

.blog-list {
    border: none !important;
}

.post-thumbnail {
    max-width: 15rem !important;
}

.blog-list {
    padding-top: 1rem !important;
}
    .blog-list .post-content p {
        overflow: visible;
    }
</style>